import * as React from "react"
import { RouteComponentProps } from "react-router"
import ResetPasswordComponent, { Names } from "./reset-password-component"
import { RepeatedPassword, User } from "../../model"
import Auth from "../../service/auth/auth"
import { resetPassword } from "../../service/sfp/resetting-service"
import { findToken } from "../../service/sfp/tokens-service"

export default class ResetPassword
extends React.Component<InjectedProps, State> {
	constructor(props) {
		super(props)
		this.state = { submitting: false }
	}

	render() {
		const token = this.props.match.params.token

		return <ResetPasswordComponent
		submitting={this.state.submitting}
		onSubmit={e => this.handleSubmit(token, e)} />
	}

	private handleSubmit(token: string, e: React.SyntheticEvent<any>) {
		e.preventDefault()
		const formData = new FormData(e.target as HTMLFormElement)
		const password: RepeatedPassword = {
			first: formData.get(Names.password) as string,
			second: formData.get(Names.passwordConfirm) as string
		}

		this.setState({ submitting: true }, () => {
			resetPassword(token, password)
			.then(user => this.resolveResetPassword(user, password.first))
			.catch(reason => {
				this.setState({ submitting: false })
			})
		})
	}

	private resolveResetPassword(user: User, password: string): void {
		findToken(user.username, password)
		.then(token => {
			Auth.signIn(token)
			this.props.history.push("/")
		})
		.catch(reason => this.props.history.push("/"))
	}
}

export interface ResetPasswordProps {}

interface Params {
	token: string
}

interface State {
	submitting: boolean
}

type InjectedProps = ResetPasswordProps & RouteComponentProps<Params>



// WEBPACK FOOTER //
// ./src/route/reset-password/index.tsx